/**
 * Servicios de Procesamiento de Imágenes
 * Cumple con .idx-rules.md: funciones < 40 líneas y desacoplamiento.
 */

/**
 * Aplica un filtro de escala de grises a un contexto 2D de canvas.
 */
export function applyGrayscale(ctx, w, h) {
  const imgData = ctx.getImageData(0, 0, w, h);
  const d = imgData.data;
  for (let i = 0; i < d.length; i += 4) {
    const g = 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2];
    d[i] = d[i + 1] = d[i + 2] = g;
  }
  ctx.putImageData(imgData, 0, 0);
}

/**
 * Recorta la porción inferior del video (zona MRZ) y la convierte a escala de grises.
 * Solo se usa en el stream continuo de video en vivo.
 */
export function cropVideoToMRZ(videoEl) {
  const mrzCanvas = document.createElement('canvas');
  const ctx = mrzCanvas.getContext('2d');
  const srcW = videoEl.videoWidth;
  const srcH = videoEl.videoHeight;
  const cropH = Math.floor(srcH * 0.40);
  const cropY = srcH - cropH;
  const targetW = Math.min(640, srcW);
  const targetH = Math.floor((cropH / srcW) * targetW);

  mrzCanvas.width = targetW;
  mrzCanvas.height = targetH;
  ctx.drawImage(videoEl, 0, cropY, srcW, cropH, 0, 0, targetW, targetH);
  applyGrayscale(ctx, targetW, targetH);
  return mrzCanvas;
}

/**
 * Redimensiona un canvas si supera las dimensiones máximas indicadas,
 * manteniendo la relación de aspecto para mejorar el rendimiento de OCR y ZXing.
 */
export function resizeCanvasIfNeeded(canvas, maxDimension = 1600) {
  const w = canvas.width;
  const h = canvas.height;
  if (w <= maxDimension && h <= maxDimension) return canvas;

  const ratio = Math.min(maxDimension / w, maxDimension / h);
  const targetW = Math.round(w * ratio);
  const targetH = Math.round(h * ratio);

  const resizedCanvas = document.createElement('canvas');
  resizedCanvas.width = targetW;
  resizedCanvas.height = targetH;
  const ctx = resizedCanvas.getContext('2d');
  ctx.drawImage(canvas, 0, 0, w, h, 0, 0, targetW, targetH);
  return resizedCanvas;
}
